import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import numbro from 'numbro';

import { Icons, IconType } from '../../../constants/icons';
import { NOT_APPLICABLE_STRING } from '../../../constants/general';
import { SVGIconType } from '../../../constants/svgIcon';
import { Profile } from '../../../models/UserStore';

import { SvgIcon } from '../SVGIcon';
import { AvatarNode } from '../AvatarNode';
import './AchievementInfoCell.css';

export type AchievementInfoCellProps = {
  userProfile: Profile;
  level: number;
  progress: number;
  currentExp: number;
  totalExp: number;
  socialExp: number;
  knowledgeExp: number;
};

export const AchievementInfoCell = memo((props: AchievementInfoCellProps) => {
  const {
    userProfile,
    level,
    progress,
    currentExp,
    totalExp,
    socialExp,
    knowledgeExp,
  } = props;
  const { t } = useTranslation();
  return (
    <div className="achievement-info-cell">
      <div className="centered-container">
        <div className="upper">
          <AvatarNode
            avatar={{
              ...userProfile.avatar,
              userId: userProfile.userId,
              source:
                userProfile.profilePicture &&
                userProfile.profilePicture.publicUrls?.small
                  ? {
                      uri: userProfile.profilePicture.publicUrls.small,
                    }
                  : NOT_APPLICABLE_STRING,
            }}
            size={80}
          />
          <div className="exp-info">
            <div className="bar-container">
              <div className="black-layer-text">{`Lv.${level}`}</div>
              <div className="progress-bar">
                <div
                  className="progress"
                  style={{ width: `${progress * 100}%` }}
                />
              </div>
            </div>
            <div className="exp-bar">
              <span className="normal-text">{t('Total: ')}</span>
              <span className="bold-text">
                {numbro(currentExp).format({
                  thousandSeparated: true,
                })}
              </span>
              <span className="normal-text">
                {` / ${numbro(totalExp).format({
                  thousandSeparated: true,
                })} XP`}
              </span>
            </div>
          </div>
        </div>
        {/* <div className="lower">
          <div className="exp-cell">
            <img className="exp-icon" src={Icons[IconType.SocialExp]} />
            <div className="exp-text-container">
              <div className="exp-name">{t('JOY Contribution')}</div>
              <div className="exp-text">{`${numbro(socialExp).format({
                thousandSeparated: true,
              })} XP`}</div>
            </div>
            <SvgIcon name={SVGIconType.Arrow} className={'arrow-icon'} />
          </div>
          <div className="divider" />
          <div className="exp-cell">
            <img className="exp-icon" src={Icons[IconType.KnowledgeExp]} />
            <div className="exp-text-container">
              <div className="exp-name">{t('Knowledge')}</div>
              <div className="exp-text">{`${numbro(knowledgeExp).format({
                thousandSeparated: true,
              })} XP`}</div>
            </div>
            <SvgIcon name={SVGIconType.Arrow} className={'arrow-icon'} />
          </div>
        </div> */}
      </div>
    </div>
  );
});
